import myImage from '../Image/myImage.jpeg'
import "../Right/Right.css"
import { motion } from 'framer-motion';
export default function Right(){
    return <motion.div 
    className='main div'
    style={{
        display:'flex',
        overflow:"hidden",
        justifyContent:"center",
        padding:'40px',
    }}
    >
     <motion.img 
     initial={{
        y:100,
        opacity:0
    }}
 animate={{
    y:0,
    opacity:1
 }}
 transition={{
    duration:0.7, 
 }}
 className='Image'
     src={myImage} alt='Not Found'/>
    </motion.div>
}